import { render, staticRenderFns } from "./InvalidDetail.vue?vue&type=template&id=190bb988"
import script from "./InvalidDetail.vue?vue&type=script&lang=js"
export * from "./InvalidDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports